<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,1C15,1,9,1,9,1C9,0.45,8.55,0,8,0C7.45,0,7,0.45,7,1C7,1,1,1,1,1C0.45,1,0,1.45,0,2C0,2.55,0.45,3,1,3C1,3,1,11,1,11C1,11.55,1.45,12,2,12C2,12,5.59,12,5.59,12C5.59,12,3.3,14.29,3.3,14.29C3.11,14.47,3,14.72,3,15C3,15.55,3.45,16,4,16C4.28,16,4.53,15.89,4.71,15.71C4.71,15.71,7,13.41,7,13.41C7,13.41,7,15,7,15C7,15.55,7.45,16,8,16C8.55,16,9,15.55,9,15C9,15,9,13.41,9,13.41C9,13.41,11.29,15.7,11.29,15.7C11.47,15.89,11.72,16,12,16C12.55,16,13,15.55,13,15C13,14.72,12.89,14.47,12.71,14.29C12.71,14.29,10.41,12,10.41,12C10.41,12,14,12,14,12C14.55,12,15,11.55,15,11C15,11,15,3,15,3C15.55,3,16,2.55,16,2C16,1.45,15.55,1,15,1C15,1,15,1,15,1ZM13,10C13,10,3,10,3,10C3,10,3,3,3,3C3,3,13,3,13,3C13,3,13,10,13,10C13,10,13,10,13,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Presentation',
} as DefineComponent
</script>
